import { computed, makeObservable } from 'mobx';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/domains/common/Common';
import { ChannelType } from 'src/domains/sportsbook/betting/betting/types';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';
import { QuickBetState } from 'src/domains/sportsbook/betting/betSlipState/quickBetState/QuickBetState';

export class ChannelState {
    public static get = AutoWeakMap.create((common: Common) => new ChannelState(common));

    private constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @computed public get channel(): ChannelType {
        const environmentState = EnvironmentState.get(this.common);
        const quickBetState = QuickBetState.getInstance();

        const { mobileAppType } = environmentState;

        if (quickBetState.isVisibleQuickBet) {
            return 'quickbet';
        }

        if (mobileAppType !== null) {
            return 'mobile';
        }

        const innerWidth = getWindowInnerWidth();

        if (innerWidth !== null) {
            const maxResolutionForKeyBoard = innerWidth < 1024;
            if (maxResolutionForKeyBoard) {
                return 'mobile';
            }
        }

        return 'desktop';
    }
}
